












import { gql } from 'graphql-tag';
import { Component, mixins } from 'nuxt-property-decorator';

import { blockColorMixin, blockableBlockColorFragment } from '@/composables/block-color';

import { VideoBlockDataFragment } from '@/graphql/generated';
import { PageBlockMixin } from '@/modules/cms';
import { largeImageFragment } from '@/graphql/queries/image.fragments';

@Component({
  graphqlData: gql`
    fragment VideoBlockData on VideoBlock {
      id
      title
      videoId
      image {
        ...LargeImageData
      }
      ...BlockColor
    }
    ${largeImageFragment}
    ${blockableBlockColorFragment}
  `,
})
export default class VideoBlock extends mixins(PageBlockMixin<VideoBlockDataFragment>(), blockColorMixin) {
  get videoId () {
    return this.data.videoId;
  }

  get youtubeId () {
    if (this.data.videoId?.includes('youtube'))
      return this.videoId?.replace(/^.+v=([\w-]+).*/, '$1');

    if (this.data.videoId?.includes('youtu.be'))
      return this.videoId?.replace(/^.+be\/([\w-]+)/, '$1');
  }

  get vimeoId () {
    if (this.data.videoId?.includes('vimeo'))
      return this.data.videoId?.replace(/^.*\/\/vimeo.com\/(.+)/, '$1');
  }
}
